import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  // .then(() => {
  //   if ('serviceWorker' in navigator && environment.production) {
  //     navigator.serviceWorker.register('/firebase-messaging-sw.js').then(function (registration) {
  //       console.log('Registration successful, scope is:', registration.scope);
  //     }).catch(function (err) {
  //       console.log('Service worker registration failed, error:', err);
  //     });
  //   }
  // })
  .catch(err => console.error(err));
